var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsNavigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5C10.9648 9.5 11.375 9.91016 11.375 10.375V13C11.375 13.9844 10.582 14.75 9.625 14.75H1.75C0.765625 14.75 0 13.9844 0 13V5.125C0 4.16797 0.765625 3.375 1.75 3.375H4.375C4.83984 3.375 5.25 3.78516 5.25 4.25C5.25 4.74219 4.83984 5.125 4.375 5.125H1.75V13H9.625V10.375C9.625 9.91016 10.0078 9.5 10.5 9.5ZM13.3438 0.75C13.6992 0.75 14 1.05078 14 1.40625V5.125C14 5.48047 13.7812 5.80859 13.4531 5.94531C13.125 6.08203 12.7422 6 12.4961 5.75391L11.375 4.63281L5.85156 10.1289C5.6875 10.293 5.46875 10.375 5.25 10.375C5.00391 10.375 4.78516 10.293 4.62109 10.1289C4.26562 9.80078 4.26562 9.22656 4.62109 8.89844L10.1172 3.375L8.99609 2.25391C8.75 2.00781 8.66797 1.625 8.80469 1.29688C8.94141 0.96875 9.26953 0.75 9.625 0.75H13.3438Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavigate);
export default __webpack_public_path__ + "static/media/icons_navigate.61f8e745.svg";
export { ForwardRef as ReactComponent };